module.exports = __webpack_public_path__ + "img/nicaragua.01b7a9a6.svg";